const communesPartenaires = [
  { nom: 'Andeville', latitude: 49.258172, longitude: 2.1673, code: '60012' },
  { nom: 'Baziège', latitude: 43.454982, longitude: 1.613846, code: '31048' },
  { nom: 'Mours', latitude: 49.13367, longitude: 2.270546, code: '95436' },
  {
    nom: 'Nogent-sur-Oise',
    latitude: 49.274714,
    longitude: 2.467452,
    code: '60463'
  },
  {
    nom: 'La Crèche',
    latitude: 46.363291,
    longitude: -0.298161,
    code: '79048'
  },
  {
    nom: 'Castanet-Tolosan',
    latitude: 43.517586,
    longitude: 1.498613,
    code: '31113'
  },
  {
    nom: 'Saint-Tropez',
    latitude: 43.273612,
    longitude: 6.639691,
    code: '83119'
  }
];

export default communesPartenaires;
